<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon>
        Anular Movilidad
        <v-spacer />
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex md12>
              <strong>Tipo de movilidad:</strong>
              {{ movilidad.tipo_movimiento }}
            </v-flex>
            <v-flex md12>
              <strong>Servidor público:</strong>
              {{ movilidad.funcionario.nombre }}
            </v-flex>
            <v-flex md6>
              <strong>Item:</strong> {{ movilidad.nro_item }}
            </v-flex>
            <v-flex md6>
              <strong>Fecha desde:</strong> {{ movilidad.fecha_desde }}
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" :loading="loading" @click="anularMovilidad()">
          <v-icon>clear</v-icon> Anular
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AprobarCambioItem from "@/components/admin/persona/components/AprobarCambioItem";
import AprobarRetiro from "../components/AprobarRetiro";
import AprobarComisionServicio from "../components/AprobarComisionServicio";
import AnularItem from "../components/AnularItem";

export default {
  components: {
    AprobarCambioItem,
    AprobarRetiro,
    AprobarComisionServicio,
    AnularItem
  },
  data() {
    return {
      loading: false,
      dialog: false,
      movilidad: {
        funcionario: {}
      }
    };
  },
  mounted() {
    this.$bus.$on("openDialogAnularTipoMovilidad", item => {
      this.movilidad = item;
      this.dialog = true;
    });
  },
  methods: {
    async anularMovilidad() {
      let resps = [];
      let correcto = true;
      try {
        this.loading = true;
        let user = this.$storage.get("user");
        if (this.movilidad.id_estado != 1 && this.movilidad.id_estado != 53) {
         
          let res = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta: "SELECT movilidad.fn_elimina_movilidad(${this.movilidad.id}, ${user.id})"){
                respuesta
              }
            }
          `
          });

          res = res.runQuery.respuesta[0].fn_elimina_movilidad;
          resps = res.split("|");
          correcto = resps[0];
          if (correcto === "1") {
            this.$message.success();
          } else {
            this.$message.error(resps[1]);
          }
          this.close();
          this.loading = false;
        } else {
          if (
            this.movilidad.id_tipo_justificacion == 5 ||
            this.movilidad.id_tipo_justificacion == 6 ||
            this.movilidad.id_tipo_justificacion == 10
          ) {
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_elimina_retiro(${this.movilidad.id},${user.id})"){
                    respuesta
                  }
                }
              `
            });
            res = res.runQuery.respuesta[0].fn_elimina_retiro;
            resps = res.split("|");
            correcto = resps[0];
            if (correcto === "1") {
              this.$message.success("La movilidad fué anulada");
            } else {
              this.$message.error(resps[1]);
            }
            this.close();
            this.loading = false;
          } 
          if (
            this.movilidad.id_tipo_justificacion ==15) {
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_anula_restructuracion(${this.movilidad.id},${user.id})"){
                    respuesta
                  }
                }
              `
            });
            res = res.runQuery.respuesta[0].fn_anula_restructuracion;
            resps = res.split("|");
            correcto = resps[0];
            if (correcto === "1") {
              this.$message.success("La movilidad fué anulada");
            } else {
              this.$message.error(resps[1]);
            }
            this.close();
            this.loading = false;
          } 
          else {
            
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_anula_movilidad(${this.movilidad.id}, ${user.id})"){
                    respuesta 
                  }
                }
              `
            });
            res = res.runQuery.respuesta[0].fn_anula_movilidad;
            resps = res.split("|");
            correcto = resps[0];
            if (correcto === "1") {
              this.$message.success("La movilidad fué anulada");
            } else {
              this.$message.error(resps[1]);
            }
            this.close();
            this.loading = false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialog = false;
      this.movilidad = {
        funcionario: {}
      };
      this.$bus.$emit("closeDialogAprobar");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/AnularTipoMovilidad.vue